import React, { useState } from "react";
import styled from "styled-components";
import Theme from "../../Theme/Theme";
import CustomDivider from "../../Utils/CustomDivider/CustomDivider";
import CustomTextField from "../../Utils/CustomTextField/CustomTextField";
import CustomButton from "../../Utils/CustomButton/CustomButton";
import Switch from "react-switch";

function SettingScreen() {
  const [haveImg] = useState(true);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setrepeatPassword] = useState("");

  const oldPasswordChange = (event) => {
    setOldPassword(event.target.value);
  };

  const newPasswordChange = (event) => {
    setNewPassword(event.target.value);
  };

  const repeatPasswordChange = (event) => {
    setrepeatPassword(event.target.value);
  };

  const [checked, setChecked] = useState(false);

  const handleChange = (checked) => {
    setChecked(checked);
  };

  const [checked2, setChecked2] = useState(false);

  const handleChange2 = (checked) => {
    setChecked2(checked);
  };

  return (
    <Container>
      <TitleElement>
        <ImgContainer>
          <TitleIcon src="/Assets/Images/SettingIconBlue.svg"></TitleIcon>
        </ImgContainer>
        <TitleText>تنظیمات</TitleText>
      </TitleElement>
      <CustomDivider></CustomDivider>
      <BottomElement>
        <GroupBoxContainer>
          <GroupBoxTitle>ویرایش عکس پروفایل</GroupBoxTitle>
          <GroupBox>
            <ChangeProfileBox>
              <Image src={"/Assets/Images/imgExample.png"}></Image>
              <RowChangeImgButton>
                {haveImg ? (
                  <>
                    <ChangeImg>تغییر عکس</ChangeImg>
                    <DeleteImg>حذف عکس</DeleteImg>
                  </>
                ) : (
                  <ChangeImg>اضافه کردن عکس</ChangeImg>
                )}
              </RowChangeImgButton>
            </ChangeProfileBox>
          </GroupBox>
        </GroupBoxContainer>
        <GroupBoxContainer>
          <GroupBoxTitle>تغییر کلمه عبور</GroupBoxTitle>
          <GroupBox>
            <RowPasswordChange>
              <TextFieldContainer>
                <CustomTextField
                  value={oldPassword}
                  onChange={oldPasswordChange}
                  Icon={"/Assets/Images/LockIcon.svg"}
                  Label={"کلمه عبور قدیمی:"}
                  type={"password"}
                ></CustomTextField>
              </TextFieldContainer>
              <TextFieldContainer>
                <CustomTextField
                  value={newPassword}
                  onChange={newPasswordChange}
                  Icon={"/Assets/Images/LockIcon.svg"}
                  Label={"کلمه عبور جدید:"}
                  type={"password"}
                ></CustomTextField>
              </TextFieldContainer>
              <TextFieldContainer>
                <CustomTextField
                  value={repeatPassword}
                  onChange={repeatPasswordChange}
                  Icon={"/Assets/Images/LockIcon.svg"}
                  Label={"تکرار کلمه عبور جدید:"}
                  type={"password"}
                ></CustomTextField>
              </TextFieldContainer>
              <PasswordChangeButton>
                <CustomButton
                  Label={"ثبت"}
                  OnClick={() => {}}
                  Width={"150px"}
                ></CustomButton>
              </PasswordChangeButton>
            </RowPasswordChange>
          </GroupBox>
        </GroupBoxContainer>
        <GroupBoxContainer>
          <GroupBoxTitle>تنظیمات درخواست ها</GroupBoxTitle>
          <GroupBox>
            <RequestSettingContainer>
              <RowRequestSetting>
                <DetailsContainer>
                  <DetailsTextTitle>ثبت درخواست پیامک شود</DetailsTextTitle>
                  <DetialsTextDiscribe>
                    با فعال سازی این ویژگی به ازای ثبت هر درخواست جدید توسط
                    دانشجویان برای شما پیامک ارسال می شود
                  </DetialsTextDiscribe>
                </DetailsContainer>
                <RowSwitchButton>
                  <Switch
                    handleDiameter={25}
                    onChange={handleChange}
                    checked={checked}
                    checkedIcon={false}
                    uncheckedIcon={false}
                    onColor={Theme.colorBluePrimary}
                    offColor={"#E3E3E3"}
                    activeBoxShadow={`0 0 2px 3px ${Theme.colorBluePrimary}`}
                  />
                  <SwtichText>{checked ? "فعال" : "غیر فعال"}</SwtichText>
                </RowSwitchButton>
              </RowRequestSetting>
              <RowRequestSetting>
                <DetailsContainer>
                  <DetailsTextTitle>
                    تغییر وضعیت درخواست پیامک شود
                  </DetailsTextTitle>
                  <DetialsTextDiscribe>
                    با فعال سازی این ویژگی به ازای تغییر وضعیت هر درخواست برای
                    شما پیامک ارسال می شود
                  </DetialsTextDiscribe>
                </DetailsContainer>
                <RowSwitchButton>
                  <Switch
                    handleDiameter={25}
                    onChange={handleChange2}
                    checked={checked2}
                    checkedIcon={false}
                    uncheckedIcon={false}
                    onColor={Theme.colorBluePrimary}
                    offColor={"#E3E3E3"}
                    activeBoxShadow={`0 0 2px 3px ${Theme.colorBluePrimary}`}
                  />
                  <SwtichText>{checked2 ? "فعال" : "غیر فعال"}</SwtichText>
                </RowSwitchButton>
              </RowRequestSetting>
            </RequestSettingContainer>
          </GroupBox>
        </GroupBoxContainer>
      </BottomElement>
    </Container>
  );
}

export default SettingScreen;

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  direction: rtl;
  box-sizing: border-box;
  padding: 5px;
`;

const BottomElement = styled.div`
  width: 100%;
  height: 700px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const TitleElement = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding-inline: 20px;
`;

const ImgContainer = styled.div`
  width: 38px;
  height: 38px;
  border: 1px solid #f5f7f8;
  background-color: transparent;
  border-radius: ${Theme.borderRadius};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TitleIcon = styled.img`
  object-fit: contain;
`;

const TitleText = styled.p`
  height: 40px;
  font-size: ${Theme.fontTitleSize};
  font-weight: ${Theme.fontInfoWeight};
  line-height: 41px;
  box-sizing: border-box;
  padding-inline: 20px;
`;

const GroupBoxContainer = styled.div`
  width: 95%;
  box-sizing: border-box;
  padding-top: 30px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const GroupBox = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border: 1px solid ${Theme.colorFontLabel};
  border-radius: ${Theme.borderRadius};
`;

const GroupBoxTitle = styled.p`
  font-size: ${Theme.fontInfoSize};
  font-weight: ${Theme.fontInfoWeight};
  position: absolute;
  box-sizing: border-box;
  padding-inline: 5px;
  top: 0;
  background-color: ${Theme.colorBackgroundBox};
  right: 30px;
`;

const ChangeProfileBox = styled.div`
  width: 100%;
  height: 130px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding-inline: 30px;
`;

const Image = styled.img`
  height: 90px;
  object-fit: contain;
  border-radius: ${Theme.borderRadius};
  margin-inline: 10px;
`;

const RowChangeImgButton = styled.div`
  width: 300px;
  height: 100px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`;

const ChangeImg = styled.button`
  min-width: 120px;
  height: 40px;
  background-color: transparent;
  border: 1px solid ${Theme.colorBluePrimary};
  border-radius: ${Theme.borderRadius};
  color: ${Theme.colorBluePrimary};
  font-size: ${Theme.fontInfoSize};
  font-weight: ${Theme.fontInfoWeight};
  font-family: "IranSans";
  padding-inline: 20px;
  cursor: pointer;
`;

const DeleteImg = styled.button`
  width: 120px;
  height: 40px;
  background-color: transparent;
  border: 0px;
  font-size: ${Theme.fontInfoSize};
  font-weight: ${Theme.fontInfoWeight};
  border-radius: ${Theme.borderRadius};
  color: ${Theme.colorRed};
  font-family: "IranSans";
  box-sizing: border-box;
  padding-inline: 10px;
  cursor: pointer;
`;

const RowPasswordChange = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding-block: 20px;
  padding-inline: 50px;
`;

const TextFieldContainer = styled.div`
  width: 400px;
`;

const PasswordChangeButton = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 15px;
`;

const RequestSettingContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

const RowRequestSetting = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding-block: 10px;
  padding-inline: 50px;
  padding-bottom: 15px;
`;

const DetailsContainer = styled.div`
  width: 35%;
  min-width: 350px;
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

const DetailsTextTitle = styled.p`
  height: 10px;
  font-size: ${Theme.fontInfoSize};
  font-weight: ${Theme.fontInfoWeight};
  color: ${Theme.colorFontBlack};
`;

const DetialsTextDiscribe = styled.p`
  font-size: ${Theme.fontNavSize};
  font-weight: ${Theme.fontNavWeight};
  color: #686868;
`;

const RowSwitchButton = styled.div`
  width: 130px;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  box-sizing: border-box;
  padding-inline: 10px;
  align-items: center;
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  margin-top: 15px;
  margin-right: 20px;
`;

const SwtichText = styled.p`
  font-size: ${Theme.fontSize};
  font-weight: ${Theme.fontWeight};
  color: ${Theme.colorFontBlack};
`;
